import { Grid, TextField, Typography } from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const Asunto = () => {
  const { proyecto, setProyecto } = useProyecto();
  const { setPromptData, promptData } = useActividadesContext();

  const handleAsunto = (event) => {
    const { value } = event.target;
    setProyecto({ ...proyecto, asunto: value });
    setPromptData((prevData) => ({
      ...prevData,
      asunto: value,
    }));
  };

  return (
    <Grid xs={12} lg={12} md={12}>
      <Typography
        id="modal-modal-title"
        sx={{
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
          color: "#336B87",
        }}
      >
        Asunto *
      </Typography>

      <TextField
        required
        id="contexto"
        placeholder="Escribe aquí el asunto del mensaje"
        name="contexto"
        fullWidth
        autoComplete="given-name"
        variant="outlined"
        value={promptData.asunto}
        onChange={handleAsunto}
        InputProps={{
          sx: {
            borderRadius: 2,
            mt: 1,
            mb: 3,
            fontFamily: "montserrat",
            fontSize: "0.75rem",
            color: "#005559",
            "&::placeholder": {
              color: "#005559",
            },
            "&:before": {
              borderBottomColor: "#005559",
            },
            "&:after": {
              borderBottomColor: "#005559",
            },
          },
        }}
      />
    </Grid>
  );
};

export default Asunto;
